import { Link, useLocation } from "react-router";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { SidebarItem } from "../../sidebar/utils/sidebarLinks";
import { isRouteActive } from "../../sidebar/utils/isRouteActive";

function Item({ item, open }: { item: SidebarItem; open: boolean }) {
  const location = useLocation();
  const isActive = isRouteActive(location.pathname, item.url);

  const iconClassName = `w-4 h-4 ${isActive ? "text-brand-primary" : ""}`;

  return open ? (
    <div className="flex items-center gap-2">
      <Link
        to={item.url}
        className={`${
          isActive ? "text-brand-primary" : ""
        } flex items-center gap-2 py-2 text-sm`}
      >
        {item.icon && <item.icon className={iconClassName} />}
        <span className={isActive ? "text-brand-primary" : ""}>
          {item.title}
        </span>
      </Link>
    </div>
  ) : (
    <div>
      <HoverCard openDelay={150} closeDelay={150}>
        <HoverCardTrigger asChild>
          <div>
            <Link to={item.url}>
              {item.icon && <item.icon className={iconClassName} />}
              <span className={isActive ? "text-brand-primary" : ""}>
                {item.title}
              </span>
            </Link>
          </div>
        </HoverCardTrigger>
        <HoverCardContent
          side="right"
          align="center"
          className="px-4 py-2 w-fit"
        >
          <Link to={item.url}>{item.title}</Link>
        </HoverCardContent>
      </HoverCard>
    </div>
  );
}

export default Item;
